<template>
  <div class="container-table-servs">
    <q-card>
      <q-card-section>
        <q-table
          :data="data"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :filter="filter"
          :pagination.sync="pagination"
          data-cy="list-autorizaciones"
          :loading="isLoading"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:top-right>
            <div>
              <q-input
                dense
                debounce="100"
                v-model="filter"
                outlined
                stack-label
                placeholder="Escriba para buscar"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              style="cursor: pointer"
            >
              <q-td key="name_and_surname" :props="props">
                {{ props.row.nameAndSurNames }}
              </q-td>
              <q-td key="email" :props="props">
                {{ props.row.email }}
              </q-td>
              <q-td key="application" :props="props">
                {{ props.row.application }}
              </q-td>
              <q-td key="service" :props="props">
                {{ props.row.service }}
              </q-td>
              <q-td key="contracting_entities" :props="props">
                {{ props.row.entity }}
              </q-td>
              <q-td key="status" :props="props">
                <span
                  v-if="!isAdminEntidad && !isDeliveryUser && !isSuperAdmin && haveEntidadesVisiblesRelated">
                  {{ statusOptions[props.row.status].label }}
                </span>
                <q-btn-toggle
                  v-else
                  data-cy="action-btn"
                  v-model="props.row.status"
                  toggle-color="primary"
                  flat
                  :options="statusOptions"
                  @input="(val) => triggerChangeStatus(val, props.row.id)"
                  />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Loading from '@/components/shared/mixins/Loading.js';
import { mapGetters } from 'vuex';

import {
  QTable,
  QCard,
  QTh,
  QTr,
  QTd,
  QCardSection,
  QBtnToggle
} from 'quasar';
import { StatusModel } from './status.model';

export default {
  components: {
    QTable,
    QCard,
    QTh,
    QTr,
    QTd,
    QCardSection,
    QBtnToggle
  },
  mixins: [Message, Loading],
  props: {
    authorizations: Array,
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin',
      isAdminEntidad: 'PF/isAdminEntidad',
      haveEntidadesVisiblesRelated: 'PF/haveEntidadesVisiblesRelated',
      isDeliveryUser: 'PF/isDeliveryUser'
    })
  },
  data () {
    return {
      pagination: {
        sortBy: 'displayOrder',
        descending: true,
        rowsPerPage: 20
      },
      data: this.authorizations,
      columns: [
        {
          name: 'name_and_surname',
          label: 'Nombre y Apellidos',
          align: 'left',
          field: 'name_and_surname',
          sortable: true
        },
        {
          name: 'email',
          label: 'E-mail',
          align: 'left',
          field: 'email',
          sortable: true
        },
        {
          name: 'application',
          label: 'Aplicación',
          align: 'left',
          field: 'application',
          sortable: true
        },
        {
          name: 'service',
          label: 'Servicio',
          align: 'left',
          field: 'service',
          sortable: true
        },
        {
          name: 'contracting_entities',
          label: 'Entidades contratantes',
          align: 'left',
          field: 'contracting_entities',
          sortable: true
        },
        {
          name: 'status',
          label: 'Estado',
          align: 'center',
          field: 'status',
          sortable: true
        }
      ],
      filter: '',
      statusOptions: StatusModel.model
    };
  },
  methods: {
    async triggerChangeStatus (value, id) {
      const authId = id;
      const statusId = value;

      if (!authId || !this.statusOptions[statusId]) return this.showError('Ha ocurrido un problema.');

      await this.changeStatus(authId, statusId);
    },
    getController (status) {
      const getKeySate = this.statusOptions[status].key;

      if (!getKeySate) return this.showError('Ha ocurrido un problema.');

      return getKeySate;
    },
    async changeStatus (authId, statusId) {
      this.showLoading();

      const controllerKey = this.getController(statusId);

      const request = {
        controller: `/Solicitud/${authId}/${controllerKey}`,
        filter: {},
        body: {}
      };

      await this.$store
        .dispatch('PF/postSuit', request)
        .then(() => {
          this.showMessage('Se ha modificado la autorización.');
          this.$emit('refreshList');
        })
        .catch((err) => {
          this.showError(err.message);
        })
        .finally(() => this.hideLoading());
    }
  },
  watch: {
    authorizations: {
      handler: function () {
        this.data = this.authorizations;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-servs {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
